import { Id, LaravelResponse, keyToUrl } from "@dgs/core";
import axios, { AxiosRequestConfig } from "axios";
import { BasePreference } from "../../types/preference";
import { meKeys } from "./meKeys";

export const meUrls = {
	preferences: keyToUrl(meKeys.preferences),
};

const preferences = (config?: AxiosRequestConfig) =>
	axios.get<LaravelResponse<BasePreference[]>>(meUrls.preferences, config);

const updateMyPreferences = (preferenceIds: Id[]) =>
	axios.put<LaravelResponse<BasePreference[]>>(meUrls.preferences, { preferenceIds: preferenceIds });

export const meService = {
	preferences,
	updateMyPreferences,
};
